import { Injectable } from '@angular/core';
import * as platform from 'platform';

@Injectable()
export class DeviceDetectorService {

  private isMobile: boolean;
  private isTablet: boolean;
  private isPc: boolean;

  constructor() {
    this.detectDeviceType();
  }

  private detectDeviceType() {
    const os = platform.os.family.toLowerCase();
    const userAgent = navigator.userAgent.toLowerCase();
    this.isMobile = os.includes('android') || os.includes('ios');
    this.isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
    this.isPc = !this.isMobile && !this.isTablet && (window.innerWidth >= 1024 || screen.width >= 1024);
  }

  detectDevice(): string{
    return platform.os.family.toLowerCase();
  }

  isMobileDevice(): boolean {
    return this.isMobile;
  }

  isTabletDevice(): boolean {
    return this.isTablet;
  }

  isPcDevice(): boolean {
    return this.isPc;
  }

}
